const levels = [
  { level: 1, title: 'Сделай по инструкции', desc: 'Сотрудник действует по готовому алгоритму. Подходит для новых сотрудников и стандартных задач, где важна точность выполнения, а не творческий подход.', example: 'Заполнить отчёт по шаблону, обработать заявки по скрипту.' },
  { level: 2, title: 'Предложи варианты', desc: 'Сотрудник изучает ситуацию и предлагает несколько вариантов решения. Руководитель выбирает лучший вариант и даёт добро на реализацию.', example: 'Подготовить три варианта программы мероприятия, руководитель выбирает оптимальный.' },
  { level: 3, title: 'Выбери вариант и реализуй', desc: 'Сотрудник анализирует варианты, выбирает лучший на своё усмотрение, согласовывает с руководителем и реализует.', example: 'Выбрать подрядчика для мероприятия, обосновать выбор, согласовать и организовать.' },
  { level: 4, title: 'Самостоятельно реши и сообщи результат', desc: 'Сотрудник полностью самостоятельно решает задачу и информирует руководителя о результате. Руководитель вмешивается только при отклонениях.', example: 'Организовать участие компании в конференции, сообщить о результате.' },
  { level: 5, title: 'Возьми ответственность за направление', desc: 'Сотрудник самостоятельно управляет целым направлением, принимает стратегические решения в своей зоне и отвечает за результат.', example: 'Руководитель отдела полностью отвечает за результаты отдела и развитие сотрудников.' },
];

export default function DelegationLevels() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Уровни делегирования
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-3 max-w-3xl mx-auto leading-relaxed">
          Степень самостоятельности сотрудника может быть разной. Руководитель постепенно повышает уровень от простого к сложному.
        </p>
        <p className="text-sm text-gray-500 text-center mb-12 max-w-2xl mx-auto">
          Это практический инструмент, а не универсальный научный стандарт. Используйте как ориентир для развития самостоятельности сотрудников.
        </p>

        <div className="space-y-4">
          {levels.map((item) => (
            <div key={item.level} className="bg-white rounded-xl border border-gray-200 p-4 md:p-5 hover:border-teal-300 transition-colors flex flex-col sm:flex-row gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-xl bg-teal-600 text-white flex items-center justify-center text-xl font-bold">
                  {item.level}
                </div>
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-gray-900 text-sm mb-1">{item.title}</h3>
                <p className="text-gray-600 text-xs leading-relaxed mb-2">{item.desc}</p>
                <p className="text-teal-600 text-xs italic">Пример: {item.example}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-3xl mx-auto text-center">
          <p className="text-sm md:text-base text-teal-800 leading-relaxed font-semibold">
            Важно двигаться от уровня к уровню постепенно, по мере роста компетентности и ответственности сотрудника. Нельзя ожидать от новичка пятого уровня самостоятельности — это приведёт к ошибкам и демотивации.
          </p>
        </div>
      </div>
    </section>
  );
}